import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-next-previous-back',
  templateUrl: './next-previous-back.component.html',
  styleUrls: ['../../vendor-application/vendor-application.component.scss']
})
export class NextPreviousBackComponent {
  @Input() currentTab: number;
  @Input() totalTabs: number;
  @Input() nextButtonDisabled: boolean = false;
  @Input() isViewMode: boolean = false; // New Input for view mode
  @Input() showNextButton: boolean = true; // Control visibility of Next button

  

  @Output() save = new EventEmitter<void>();
  @Output() next = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();

  onSave() {
    this.save.emit();
  }

  onNext() {
    this.next.emit();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  onBack() {
    this.back.emit();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  get showBackButton() {
    return this.currentTab > 0;
  }

  get nextButtonText() {
    return this.currentTab === this.totalTabs -1 ? 'Submit' : 'Next';
  }
}
